import inicialState from './pcr.state';
import * as actions from './pcr.action';

const pcrReducer = (state = inicialState, action) => {
  switch (action.type) {
    case actions.PCR_FINALIZADA:
      return {
        ...state,
        pcrFinalizada: action.payload.pcrFinalizada,
      };    
    default:
      return state;
  }
};

export default pcrReducer;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/pcr/pcr.reducer.js